import React, { useState } from "react";
import { useGetAttendeesInEventWithKeyDoctorsMasterData } from "../../hooks/useAttendee";
import { toast } from "react-toastify";

function RefreshAttendeesFromMasterData({ eventId }) {
  const { mutate: refreshAttendees } =
    useGetAttendeesInEventWithKeyDoctorsMasterData();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    refreshAttendees(eventId, {
      onSuccess: (result) => {
        if (result?.hasUpdates) {
          toast.success("Updated data Successfully");
        } else {
          toast.info("No changes happened");
        }
      },
      onError: () => {
        toast.error("HCP Master Data is not complete");
      },
      onSettled: () => {
        setIsRefreshing(false);
      },
    });
  };

  return (
    <button
      data-track="refresh-attendees-button"
      data-module="Attendees"
      onClick={handleRefresh}
      disabled={isRefreshing}
      className={`bg-blue-600 hover:bg-blue-700 transition-colors duration-200 text-white rounded-md px-4 py-2 flex items-center gap-2 ${
        isRefreshing ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
      }`}
    >
      <i
        className={`fa-solid fa-rotate ${isRefreshing ? "animate-spin" : ""}`}
      ></i>
      {isRefreshing ? "Refreshing..." : "Refresh Data"}
    </button>
  );
}

export default RefreshAttendeesFromMasterData;
